<h3 class="mb15">{{paidClient ? 'Remove from the list' : 'Remove a page'}}</h3>
<p class="mb30" *ngIf="!paidClient">Removing a page from the list will turn off<br> the optimization for that page.</p>
<p class="mb30" *ngIf="paidClient">Removing this page will reverse your assigned<br> optimization level back to default.</p>
<div class="buttons-wrap">
  <button class="ds-btn mr20" (click)="cancel()"><span>Cancel</span></button>
  <button class="ds-btn-red" (click)="close()"><span>Remove</span></button>
</div>

